var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagTuvalu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.8506C32 25.6871 24.8365 32.8506 16.0001 32.8506C7.1635 32.8506 0 25.6871 0 16.8506C0 16.8544 16.0001 0.852336 16.0001 0.850586C24.8365 0.850586 32 8.01409 32 16.8506Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65216 16.8508H13.0485L8.34779 11.2856L7.65216 13.3726V16.8508Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 13.8994L10.4344 8.50293H15.9996L15.9996 13.8994Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9572 16.8504H16C16 16.8361 16 16.8221 16 16.8076C15.9858 16.8219 15.9715 16.8362 15.9572 16.8504Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 9.1984C16.0001 6.38309 16.0001 4.53834 16.0001 0.850586H15.9974C7.162 0.852086 0 8.0149 0 16.8506H8.34787V12.1499L13.0486 16.8506H15.9573C15.9716 16.8363 15.9858 16.8221 16.0001 16.8078C16.0001 15.7298 16.0001 14.768 16.0001 13.8992L11.2992 9.1984H16.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09466 2.9375C5.59223 4.36244 3.51185 6.44281 2.08691 8.94525V16.8506H6.26085V7.11156V7.11144H16C16 5.795 16 4.54087 16 2.9375H8.09466Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.8828L10.3153 9.19824H8.34784V9.19837L15.9999 16.8504H16C16 16.8504 16 15.4937 16 14.8828Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4629 27.2852L17.8083 28.348H18.9258L18.0217 29.0049L18.3671 30.0677L17.4629 29.4109L16.5588 30.0677L16.9042 29.0049L16 28.348H17.1175L17.4629 27.2852Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3632 20.3286L26.7085 21.3915H27.8261L26.922 22.0484L27.2675 23.1112L26.3632 22.4544L25.4591 23.1112L25.8045 22.0484L24.9003 21.3915H26.0178L26.3632 20.3286Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5937 9.89404L28.9391 10.9569H30.0567L29.1526 11.6138L29.4979 12.6766L28.5937 12.0198L27.6897 12.6766L28.035 11.6138L27.1309 10.9569H28.2484L28.5937 9.89404Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1456 17.5459L29.4909 18.6088H30.6084L29.7044 19.2657L30.0497 20.3285L29.1456 19.6717L28.2415 20.3285L28.5869 19.2657L27.6826 18.6088H28.8002L29.1456 17.5459Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.065 24.7857L20.0609 25.2931L20.8511 24.5029L20.6764 25.6066L21.672 26.114L20.5682 26.2889L20.3934 27.3927L19.8861 26.3969L18.7822 26.5718L19.5724 25.7816L19.065 24.7857Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.065 20.6114L20.0609 21.1188L20.8511 20.3286L20.6764 21.4324L21.672 21.9397L20.5682 22.1145L20.3934 23.2184L19.8861 22.2226L18.7822 22.3975L19.5724 21.6073L19.065 20.6114Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5436 23.2871L23.5396 23.7946L24.3297 23.0044L24.155 24.1081L25.1507 24.6155L24.0468 24.7903L23.872 25.8941L23.3647 24.8983L22.2609 25.0733L23.0511 24.2831L22.5436 23.2871Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5436 14.3507L23.5396 14.8581L24.3297 14.0679L24.155 15.1716L25.1507 15.6789L24.0468 15.8538L23.872 16.9576L23.3647 15.9619L22.2609 16.1367L23.0511 15.3466L22.5436 14.3507Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9147 14.2437L26.9106 14.7511L27.7008 13.9609L27.526 15.0647L28.5218 15.572L27.4179 15.7469L27.2431 16.8507L26.7358 15.8549L25.632 16.0298L26.4221 15.2396L25.9147 14.2437Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.850586)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTuvalu);
export default __webpack_public_path__ + "static/media/flag_tuvalu.754218322a5897b5a9f4e2981c8eca0c.svg";
export { ForwardRef as ReactComponent };